import TemplateView from "../TemplateView";
import $ from 'jquery'

export class InvisibleMoire extends TemplateView {
    static getInstance() {
        return getInstance()
    }

    templateHtml() {
        return "<div class='invisibleMoireContainer'/>"
    }
}

let instance = null
const getInstance = () => {
    if (!instance) {
        instance = new InvisibleMoire().init($("body"))
    }
    return instance
}


// WEBPACK FOOTER //
// ./web/js/components/InvisibleMoire.js